import { useTranslation } from '@kostbar/i18n'
import { PublishBundleForm } from '../components/publish-bundle-form'
import { BundleStatus } from '../components/bundle-status'
import { PermissionGate } from '@/shared/components/permission-gate'
import { ACTIONS } from '@/shared/constants/actions'

export function BundlesPage() {
  const { t: tBundles } = useTranslation('bundles')
  return (
    <PermissionGate action={ACTIONS.BUNDLE_PUBLISH}>
      <div>
        <div className="mb-6">
          <h1 className="text-3xl font-bold">{tBundles('title')}</h1>
          <p className="text-muted-foreground mt-2">{tBundles('subtitle')}</p>
        </div>

        <div className="space-y-6">
          <PublishBundleForm />
          <BundleStatus />
        </div>
      </div>
    </PermissionGate>
  )
}
